export const APPROVED = "Approved";
export const REJECTED = "Rejected";
export const PENDING = "Pending";
export const DRAFT = "Draft";
export const AUTO_APPROVED = "Auto Approved";
export const CHANGE_NOTIFICATION = "View Only";
